import { Injectable } from '@angular/core';
import {Network} from "@ionic-native/network";


@Injectable()
export class NetworkService {

  constructor(private network: Network){

  }

  /**
   * Active when device loose internet connection
   * @returns {Observable<any>}
   */
  onConnexionLost(){
    return this.network.onDisconnect();
  }

  /**
   * Active when device connect to the internet
   * @returns {Observable<any>}
   */
  onConnexion(){
    return this.network.onConnect();
  }

  /**
   * Active when a change happen on internet connexion
   * @returns {Observable<any>}
   */
  onConnexionChange(){
    return this.network.onchange();
  }

  /**
   * Return internet connexion type
   * @returns {string}
   */
  networkType(){
    return this.network.type;
  }

  /**
   * Return internet speed
   * @returns {string}
   */
  downLink(){
    return this.network.downlinkMax;
  }

}



// WEBPACK FOOTER //
// ./src/services/network.service.ts